import { Globe } from "@/components/bnp-icons";
import React, { useState } from "react";

const LanguageDropdown = () => {
  const languages = [
    { code: "EN", name: "English" },
    { code: "ES", name: "Spanish" },
    { code: "FR", name: "French" },
    { code: "DE", name: "German" },
    { code: "CN", name: "Chinese" },
    { code: "JP", name: "Japanese" },
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);

  const ChevronDown = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#133345"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 9l6 6 6-6" />
    </svg>
  );

  const ChevronUp = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#133345"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 15l-6-6-6 6" />
    </svg>
  );

  return (
    <div className="relative w-fit text-sm">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-[66.83px] h-[24px] flex items-center justify-between bg-inherit"
      >
        <div className="flex items-center gap-1 text-bnp-dark">
          <Globe />
          <span className="font-medium">{selectedLanguage.code}</span>
        </div>
        {isOpen ? <ChevronUp /> : <ChevronDown />}
      </button>

      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
          {languages.map((language) => (
            <div
              key={language.code}
              className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-2 text-bnp-dark"
              onClick={() => {
                setSelectedLanguage(language);
                setIsOpen(false);
              }}
            >
              <span className="font-medium">{language.code}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageDropdown;
